import { STATUS } from "../../constants/avatar";

const initialState = {
  id: "",
  item: {
    status: STATUS.INIT,
  },
  loading: false,
  tempPassword: "",
  password: "",
  passwordExpiredAt: 0,
  // isConfirmed: false,
  status: STATUS.INIT,
};

export const AvatarConstant = {
  SET_ID: "AVATAR_SET_ID",
  SET_AVATAR: "AVATAR_SET_AVATAR",
  SET_TEMP_PASSWORD: "AVATAR_SET_TEMP_PASSWORD",
  SET_PASSWORD: "AVATAR_SET_PASSWORD",
  SET_LOADING: "AVATAR_SER_LOADING",
  SET_AVATAR_STATUE: "AVATAR_SET_AVATAR_STATUE",
  // SET_AVATAR_CONFIRMED: "AVATAR_SET_AVATAR_CONFIRMED",
};

export const AvatarReducer = (state = initialState, action) => {
  switch (action.type) { 
    case AvatarConstant.SET_PASSWORD:
      const _passwordExpiredAt = new Date().getTime() + 1000 * 60 * 10;
      return {
        ...state,
        password: action.value,
        passwordExpiredAt: _passwordExpiredAt,
      };
    case AvatarConstant.SET_LOADING:
      return {
        ...state,
        loading: action.bool,
      };
    case AvatarConstant.SET_TEMP_PASSWORD:
      return {
        ...state,
        tempPassword: action.value,
      };
    case AvatarConstant.SET_ID:
      return {
        ...state,
        id: action.id,
      };
    case AvatarConstant.SET_AVATAR:
      return {
        ...state,
        item: action.item,
        status: action.item?.status ?? "", 
      };
    case AvatarConstant.SET_AVATAR_STATUE:
      return {
        ...state,
        status: action.status,
      }
    default:
      return state
  }
};
